var M = Object.defineProperty;
var P = (e, n, t) => n in e ? M(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var d = (e, n, t) => (P(e, typeof n != "symbol" ? n + "" : n, t), t);
import { jsx as g } from "react/jsx-runtime";
import f, { useState as w, useId as O, useEffect as j } from "react";
import K from "react-dom";
import s from "jquery";
var l, c = K;
if (process.env.NODE_ENV === "production")
  l = c.createRoot, c.hydrateRoot;
else {
  var I = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  l = function(e, n) {
    I.usingClientEntryPoint = !0;
    try {
      return c.createRoot(e, n);
    } finally {
      I.usingClientEntryPoint = !1;
    }
  };
}
class q {
  constructor(n, t) {
    d(this, "context");
    d(this, "$");
    this.context = n, this.$ = t;
  }
  get lang() {
    return this.context.options.langInfo;
  }
}
function A(e, n) {
  const t = s;
  t.summernote.plugins[e] && console.warn(`${e} plugin is already exists.`), t.extend(t.summernote.plugins, {
    [e]: function(o) {
      return new n(o, t);
    }
  });
}
function W(e) {
  return (n) => {
    let t = {
      container: e.container || "body",
      tooltip: e.tooltip || "sample"
    };
    if (e.title && !e.element && !e.render)
      return t.contents = e.title, t.click = () => {
        var o;
        (o = e == null ? void 0 : e.onClick) == null || o.call(e, n);
      }, n.ui.button(t).render();
    {
      const i = n.ui.button(t).render(), r = { context: n, ...e.props };
      return e != null && e.render && l(i[0]).render(e.render(r)), e != null && e.element && f.isValidElement(f.createElement(e.element, r)) && l(i[0]).render(f.createElement(e.element, r)), i;
    }
  };
}
function Y(e) {
  const n = s;
  n.extend(!0, n.summernote.lang, e);
}
function z(...e) {
  const n = s;
  if (e.length === 1)
    n.extend(!0, n.summernote.options.keyMap, e[0]);
  else if (e.length === 2) {
    const [t, o] = e[0].split(",");
    n.extend(!0, n.summernote.options.keyMap, {
      pc: {
        [t]: e[1]
      },
      mac: {
        [o || t]: e[1]
      }
    });
  }
}
function L(e) {
  return `${e}-container`;
}
function D(e) {
  return document.getElementById(L(e));
}
function G({ value: e, children: n, className: t = "", containerClassName: o, opt: i, ...r }) {
  const {
    initInvoke: y,
    onInit: E,
    onBlur: _,
    onBlurCodeview: S,
    onChange: $,
    onEnter: h,
    onFocus: R,
    onImageUpload: v,
    onKeydown: B,
    onKeyup: b,
    onMousedown: x,
    onMouseup: C,
    onPaste: N
  } = r, k = {
    onInit: (m) => {
      E && E(m), y && y((...u) => m.note.summernote(...u));
    },
    onBlur: _,
    onBlurCodeview: S,
    onChange: $,
    onEnter: h,
    onFocus: R,
    onImageUpload: v,
    onKeydown: B,
    onKeyup: b,
    onMousedown: x,
    onMouseup: C,
    onPaste: N
  }, [a] = w(r.id || O());
  return j(() => {
    const m = typeof r.dialogsInBody > "u" ? !0 : r.dialogsInBody, u = D(a);
    if (!u) {
      console.error(`summernote element is not exists. id: ${a}`);
      return;
    }
    return s(u).summernote({ ...r, callbacks: k, ...i, dialogsInBody: m }), () => {
      s(u).summernote("destroy");
    };
  }, [r]), /* @__PURE__ */ g("div", { className: `react-summernote ${t}`, children: /* @__PURE__ */ g("div", { id: `${a}-container`, className: `react-summernote-container ${o}`, children: e || n }) });
}
export {
  G as Summernote,
  q as SummernotePlugin,
  W as createSummernoteButton,
  A as createSummernotePlugin,
  L as getContainerId,
  D as getElement,
  Y as setSummernoteLang,
  z as setSummernoteShortcut
};
